// extracted by mini-css-extract-plugin
var _1 = "overflow-text__T4f8C";
export { _1 as "overflowText" }
